var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgField(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 321,
    height: 214,
    viewBox: "0 0 321 214",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2891",
    "data-name": "Group 2891",
    transform: "translate(-1358 -829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2573",
    "data-name": "Rectangle 2573",
    transform: "translate(1358 829)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 321,
    height: 214,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 319,
    height: 212,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M-8483.393-2706.575l-.107,211.079",
    transform: "translate(10002 3537)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M-8644-2671.964h319.788",
    transform: "translate(10002 3537)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M-8644-2671.964h319.788",
    transform: "translate(10002 3679)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M-8483.393-2706.575l-.107,142",
    transform: "translate(9882 3571.611)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M-8483.393-2706.575l-.107,142",
    transform: "translate(9914 3571.611)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M-8483.5-2706.575l.107,142",
    transform: "translate(10122 3571.611)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M-8483.5-2706.575l.107,142",
    transform: "translate(10090 3571.612)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.4
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "left-corner",
    cx: 8,
    cy: 46,
    r: 5,
    fill: "#EE4A9B",
    stroke: "#EE4A9B",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "right-corner",
    cx: 8,
    cy: 168,
    r: 5,
    fill: "#EE4A9B",
    stroke: "#EE4A9B",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "left-raider",
    cx: 135,
    cy: 55,
    r: 5,
    fill: "#EE4A9B",
    stroke: "#EE4A9B",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "right-raider",
    cx: 135,
    cy: 159,
    r: 5,
    fill: "#EE4A9B",
    stroke: "#EE4A9B",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "left-cover",
    cx: 40,
    cy: 70,
    r: 5,
    fill: "#EE4A9B",
    stroke: "#EE4A9B",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "right-cover",
    cx: 40,
    cy: 144,
    r: 5,
    fill: "#EE4A9B",
    stroke: "#EE4A9B",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "all-rounder",
    cx: 40,
    cy: 107,
    r: 5,
    fill: "#EE4A9B",
    stroke: "#EE4A9B",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgField);
export default __webpack_public_path__ + "static/media/field.b1ca139638ad39bb081be82b34c853cf.svg";
export { ForwardRef as ReactComponent };